import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';

interface FileCachUploadProps {
  file?: File;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
}
const FileCachUpload = ({file, setFile}: FileCachUploadProps) => {
  return (
    <div className=" flex  w-full h-[54px] justify-between  items-center">
      <button className="min-w-[20px]" onClick={() => setFile(undefined)}>
        <SpanIcon className="icon-nameClose-remove" />
      </button>

      <div className="flex gap-2 w-100 h-100 items-center justify-end">
        <div className="flex flex-col text-gray-950 items-end">
          <span className="text-md font-Medium line-clamp-1" dir="ltr">
            {file?.name}
          </span>
          {file && (
            <span className="text-md font-Regular">
              {Math.round((file.size / 1024) * 100) / 100}KB
            </span>
          )}
        </div>
        <img
          width={40}
          height={40}
          className="w-[40px] h-[40px]"
          src="https://s3.ir-thr-at1.arvanstorage.ir/my-chats/pdfIcon.svg"
          alt="file"
        />
      </div>
    </div>
  );
};

export default FileCachUpload;
